import layout from '@/views/layout';
/**
 * 路由
 * hidden       侧边栏是否隐藏,默认为false
 */
const urlRouters = [
    {
        path: '/',
        component: layout,
        redirect: '/equipment/portable/equi/index',
        children: [
            {path: 'home',component: () => import('@/views/equipment/portable/equi/index'),meta: {title:'首页',bread:'首页'}},
            {path: 'inventory/batch/addressBook',component: () => import('@/views/inventory/batch/addressBook'),meta: {title:'地址薄管理',bread:'地址薄管理'}},
        ],
    },
    {
        path: '/login',
        component: () => import('@/views/login'),
        meta: {title: '登录'}
    },
    {
        path: '/404',
        meta: {title: '404'},
        component: () => import('@/views/login'),
    }
];

export default urlRouters